module.exports = __webpack_public_path__ + "img/no_credits_illustration.f889cc65.svg";